const state = {
  notification: {
    status: false,
    type: 'info',
    closable: true,
    timer: 6000,
    message: ''
  }
}

const actions = {
  requestFailure: ({commit}, msg) => {
    const text = (!msg || (Object.entries(msg).length === 0 && msg.constructor === Object)) ?
                'Something went wrong, try again a bit later!' : msg;
    commit("setNotification", {
      status: true,
      type: 'danger',
      message: text
    })
  }
}

const mutations = {
  setNotification: (state, data) => {
    Object.keys(data).forEach(key => {
      state.notification[key] = data[key];
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
